import * as moment from 'moment';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

pdfMake.vfs = pdfFonts.pdfMake.vfs;


pdfMake.fonts = {
  Roboto: {
    normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
    bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
    italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
    bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
  },
  FontAwesome: {
    normal: "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/fonts/fontawesome-webfont.ttf"
  }
};

export const NUMBER_OF_RECORDS = 50;

export const driverVerificationLabels = {
    isFirstName: 'First Name',
    isLastName: 'Last Name',
    isProfileImageURL: 'Profile Image',
    isPhoneNumber: 'Contact Number',
    isContactNumber: 'Phone Number',
    isEmail: 'Email',
    isDob: 'Date of Birth',
    isLanguageSpoken: 'Languages Spoken',
    isAttestation: 'Attestation',
    address: {
        isName: 'Address',
        isCity: 'City',
        isState: 'State',
    },
    driverLicense: {
        isImage: "Front of Driver's License",
        isNumber: 'License Number',
        isIssueDate: 'License Issue Date',
        isExpireDate: 'License Expiration Date',
        isStateIssue: 'License State Issued',
    },
    examinations: {
        isPhyExamImage: 'Latest Physical Exam',
        isPhyExamDate: 'Latest Physical Exam Date',
        isPhyExamExpireDate: 'Latest Physical Exam Expiration Date',
        isDrugTestImage: 'Drug Test',
        isDrugTestDate: 'Drug Test Date',
        isDrugTestExpireDate: 'Drug Test Expiration Date',
    },
    isAbuse: 'Convicted of child abuse or felony?',
    isViolations: 'Vehicle Violations',
    isServiceAreas: 'Service Areas',
    isSignature: 'Driver Signature',

};


export const companyVerificationLabels = {
    isName: 'Company Name',
    isTimeZone: 'Timezone',
    isProfileImageURL: 'Company Logo',
    isPhoneNumber: 'Office Phone Number',
    isSecondaryPhoneNumber: 'Secondary Phone Number',
    isEmail: 'Email',
    isServiceAreas: 'Service Area',
    isHoursofOperation: 'Hours of Operation',
    address: {
      isName: 'Address',
      isCity: 'City',
      isState: 'State',
    },
    owner: {
      isFirstName: 'First Name',
      isLastName: 'Last Name',
      isPhoneNumber: 'Phone Number',
      isEmail: 'Email',
      isDriverLicenseImage: 'Driver License',
      address: {
        isName: 'Owner Address',
        isCity: 'Owner City',
        isState: 'Owner State',
      },
    },
    documents: {
      isHIPAATrainingCertificateImage: 'HIPAA Training Certificate',
      isHIPAATrainingDate: 'HIPAA Training Date',
      isFraudWasteAndAbuseCertificateImage: 'Fraud, Waste and Abuse Training Certificate',
      isFraudWasteAndAbuseCertificateDate: 'Fraud, Waste and Abuse Training Completion Date',
      isNonDisclosureAgreementImage: 'Signed Non-Disclosure Agreement',
      isTransportationProviderAgreementImage: 'Signed Transportation Provider Agreement',
      isW9Image: 'W9 Form Image',
      isDisclosureofOwnershipImage: 'Disclosure of Ownership',
      isEFTFormImage: 'EFT Form',
      isVoidedCheckImage: 'Voided Check',
      isDriverScheduleImage: 'Driver Schedule',
      isVehicleScheduleImage: 'Vehicle Schedule',
      isVehicleForHireLicenseImage: 'Vehicle For Hire License',
    },
    insurance: {
      isGeneralLiabilityInsuranceImage: 'Certificate of General Liability Insurance',
      isGeneralLiabilityInsuranceDate: 'Certificate of General Expiration Date',
      isAutoLiabilityInsuranceImage: 'Auto Liability Insurance',
      isAutoLiabilityInsuranceDate: 'Auto Liability Insurance Date',
    },
    bankDetails: {
      isName: 'Bank Name',
      isAccountNumber: 'Account Number',
      isRoutingNumber: 'Routing Number',
    },
    taxInformation: {
    isName: 'Name',
    isNpi: 'Npi',
    isTaxId: 'Tax Id',
    isTaxonomy: 'Taxonomy',
    },
   focalPersonInformation: {
    isName: 'Name',
    isEmail: 'Email',
    isContactNumber: 'Contact Number',
    isPhoneNumber: 'Phone Number',
   },
  };
  
  export const vehicleVerificationLabels = {
    isDescription: 'Description',
    isVin: 'VIN',
    isLicensePlateNumber: 'License Plate Number',
    isYear: 'Year',
    isMake: 'Make',
    isModel: 'Model',
    isColor: 'Color',
    isSpaceType: 'Space type',
    garageAddress: {
      isName: 'Garage Street Address',
      isCity: 'Garage City',
      isState: 'Garage State',
    },
    isServiceAreas: 'Service Areas',
    images: {
      isRegistration: 'Registration',
      isInspectionReport: 'Inspection Report',
      isVehicle: ' Vehicle Image Front',
      isBack: 'Vehicle Image Back',
      isLeft: 'Vehicle Left Image',
      isRight: 'Vehicle Right Image',
    },
    dates: {
      isRegistration: 'Registration Expiration Date',
      isInspectionReport: 'Inspection Report Completion Date'
    },
  };

  export function exportToCsv(filename:any, rows:any) {
  var processRow = function (row:any) {
    var finalVal = '';
    for (var j = 0; j < row.length; j++) {
      var innerValue = row[j] === null || row[j] === undefined || row[j] === "" ? 'n/a' : row[j].toString();
      if (row[j] instanceof Date) {
        innerValue = row[j].toLocaleString();
      };
      var result = innerValue.replace(/"/g, '""');
      if (result.search(/("|,|\n)/g) >= 0)
        result = '"' + result + '"';
      if (j > 0)
        finalVal += ',';
      finalVal += result;
    }
    return finalVal + '\n';
  };

  var csvFile = '';
  for (var i = 0; i < rows.length; i++) {
    csvFile += processRow(rows[i]);
  }

  var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });

  var link = document.createElement("a");
  if (link.download !== undefined) { // feature detection
    // Browsers that support HTML5 download attribute
    var url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  }
}


export function getRandomString(length: number): string {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result
}



export async function urlToBase64(url:any) {
  var res = await fetch(url, {
    method: "GET",
    headers: { "Cache-Control": "no-cache" },
  });
  var blob = await res.blob();

  const result = await new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.addEventListener(
      "load",
      function () {
        resolve(reader.result);
      },
      false
    );

    reader.onerror = () => {
      return reject();
    };
    reader.readAsDataURL(blob);
  });

  return result;
}


export function base64ToFile(base64Data: string, filename: string): File {
  const arr = base64Data.split(',');
  const mime = arr[0].match(/:(.*?);/)?.[1] || 'image/png';
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

export function generatePdf(documentDefinition: any, action: "download" | "open" | "print" = "download", filename = "black-honda") {
  return new Promise<void>((resolve, reject) => {
    try {
      const pdfDocGenerator = pdfMake.createPdf(documentDefinition);

      switch (action) {
        case "open":
          pdfDocGenerator.open();
          resolve();
          break;
        case "print":
          pdfDocGenerator.print();
          resolve();
          break;
        case "download":
          pdfDocGenerator.download(`${filename}.pdf`);
          resolve();
          break;
        default:
          pdfDocGenerator.open();
          resolve();
          break;
      }
    } catch (err) {
      reject(err);
    }
  });
}